import React from "react";
import { p, d, setting } from "./Data/info";
import logo from "./Data/logo.png";
import Btn from "./components/btn";
import Catalog from "./components/catalog";
import "./App.scss";
function App() {
    return (
        <div className="App">
            <div className="photo">
                <img src={logo} alt="logo" />
            </div>
            <div className="word">
                {/* <div className="title">{setting.title}</div> */}
                <div className="subtitle">{setting.subt}</div>
            </div>

            <div className="btns podcast">
                <Catalog title="Podcast" />
                {p.map((item) => {
                    return <Btn data={item} />;
                })}
            </div>

            <div className="btns">
                <Catalog title={setting.des} />
                {d.map((item) => {
                    return <Btn data={item} />;
                })}
            </div>
        </div>
    );
}

export default App;
